module.exports = __webpack_public_path__ + "static/media/my-saved-items.b6859c79.svg";